

import React, { Component } from 'react';

import SyncSelect, { components as selectComponents } from 'react-select';
import AsyncSelect from 'react-select/async';
import cx from 'classnames';
import LabelWrapper from '../../LabelWrapper';
import styles from '../styles/dropdown';
import DropdownLabel from './DropdownLabel';
import Icon from '../../Icon';
import { DROPDOWN_VALUE, DROPDOWN_LABEL } from '../styles/dropdownLabel';
import { getPrefix } from '../utils';
import DropdownLabelContent from './DropdownLabelContent';
import Text from '../../Text/Text';
import { Divider } from '../../Divider';
import '../styles/_dropdown.scss';



















































class Dropdown extends Component {
  // We default these to false because babel transpiles Boolean() below incorrectly
  static defaultProps = {
    isClearable: false,
    isSearchable: false,
    multi: false,
    labelProps: {},
    placeholder: 'Select',
    cutLongLabels: true,
    isExpandIconVisible: true,
    selectStyles: {},
    components: {}
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedItems: ''
    };
  }

  getOption = (

  option,
  { ignoreButton } = {}) =>
  {
    const { type, children, placeholder } = this.props;

    if (!ignoreButton && type === 'BUTTON') {
      if (typeof children === 'string' || children === 'number') {
        return { value: null, label: <Text highlighted>{children}</Text> };
      }

      return {
        value: null,
        label: children || <Text highlighted>{placeholder}</Text>
      };
    }

    if (typeof option === 'string') {
      return { value: option, label: option };
    }

    return option;
  };

  getOptions(options) {
    return options ?
    options.map((option) => this.getOption(option, { ignoreButton: true })).filter(Boolean) :
    [];
  }

  createSingleValue = ({ data: { label, prefix, prefixSize } }) => {
    const {
      hideSelectedLabel,
      customPrefix,
      disabled,
      cutLongLabels
    } = this.props;

    return (
      <div className={cx('dropdown-option', DROPDOWN_VALUE)}>
        <div className={cx('dropdown-option__content', DROPDOWN_LABEL)}>
          {getPrefix({ prefix: customPrefix || prefix, size: prefixSize })}
          {
          !hideSelectedLabel &&
          <DropdownLabelContent
            label={label}
            disabled={disabled}
            cutLongLabels={cutLongLabels} />}



        </div>
      </div>);

  };

  isOptionSelected = (label) => {
    const { selectedItems } = this.state;

    return selectedItems && Array.isArray(selectedItems) ?
    selectedItems.some((item) => item.label === label) :
    false;
  };

  createDropdownLabel = (RSProps) => {
    const {
      prefixSize,
      multi,
      disabled,
      cutLongLabels
    } = this.props;
    const { label } = RSProps;

    return (
      <DropdownLabel
        isSelected={this.isOptionSelected(label)}
        prefixSize={prefixSize}
        disabled={disabled}
        {...RSProps}
        isMulti={multi}
        cutLongLabels={cutLongLabels} />);


  };

  createDropdownArrow = ({ selectProps: { value } }) => {
    const { disabled, showSelectedSuffix, isExpandIconVisible } = this.props;

    if (!isExpandIconVisible) {
      return null;
    }

    return (
      <>
        {showSelectedSuffix &&
        <div
          className="dropdown-option__suffix"
          style={{ color: disabled ? '#CBD0DB' : void 0 }}>

            {value && value.suffix}
          </div>}

        <Icon
          size={8}
          className="dropdown__icon"
          color={disabled ? 'michael' : void 0}
          name="arrowdown" />

      </>);

  };

  createGroupDivider = (props) => {
    const firstGroupLabel = props.selectProps.options[0].label;
    const currentGroup = props.data;
    const currentGroupLabel = currentGroup.label;

    const shouldShowDivider = firstGroupLabel !== currentGroupLabel && !currentGroup.length;

    return (
      <div className="group-wrapper">
        {
        shouldShowDivider ?

        <Divider className="divider" /> :

        null}

        <selectComponents.Group {...props} />
      </div>);

  };

  onSelectionChange = (result) => {
    const { onChange } = this.props;

    this.setState({ selectedItems: result });

    /* istanbul ignore else */
    if (onChange) {
      onChange(result);
    }
  };

  static Label = DropdownLabel;

  render() {
    const {
      onChange,
      placeholder,
      id,
      label,
      disabled,
      defaultValue,
      value,
      multi,
      classNamePrefix,
      className,
      renderMenuLocally,
      options,
      isSearchable,
      searchPromptText,
      noResultsText,
      isClearable,
      loadOptions,
      type,
      labelProps,
      menuWidth,
      children,
      fixedButtonValue,
      isExpandIconVisible,
      maxMenuHeight,
      selectStyles,
      components,
      ...otherSelectProps
    } = this.props;

    const Select = loadOptions ? AsyncSelect : SyncSelect;
    const searchPrompt = searchPromptText || 'Enter text to search';
    const noResults = noResultsText || 'No results';

    return (
      <LabelWrapper {...labelProps} className="dropdown__label-wrapper" id={id} label={label} disabled={disabled}>
        <Select
          id={!label ? id : /* istanbul ignore next */void 0}
          className={cx(
            'dropdown',
            {
              'dropdown--btn': type === 'BUTTON',
              'dropdown--indicators-disabled': !isExpandIconVisible,
              'dropdown--searchable': isSearchable
            },
            className
          )}
          classNamePrefix="react-select"
          styles={styles({
            disabled,
            menuWidth,
            overrides: selectStyles
          })}
          placeholder={placeholder}
          isDisabled={disabled}
          options={this.getOptions(options)}
          defaultValue={this.getOption(defaultValue, { ignoreButton: true })}
          value={
          value || value === null || fixedButtonValue ?
          this.getOption(value, { ignoreButton: !fixedButtonValue }) :
          void 0}

          isMulti={multi}
          onChange={this.onSelectionChange}
          hideSelectedOptions={false}
          menuPortalTarget={renderMenuLocally ? /* istanbul ignore next */void 0 : document.body}
          components={{
            Option: this.createDropdownLabel,
            SingleValue: this.createSingleValue,
            DropdownIndicator: this.createDropdownArrow,
            Group: this.createGroupDivider,
            ...components
          }}
          isSearchable={Boolean(isSearchable)}
          isClearable={Boolean(multi || isClearable)}
          loadOptions={loadOptions}
          noOptionsMessage={({ inputValue }) => inputValue ? noResults : searchPrompt}
          maxMenuHeight={maxMenuHeight}
          {...otherSelectProps} />

      </LabelWrapper>);

  }
}

export default Dropdown;